import { CoreEnv } from '@eventbrite/context-gen';
import { EBEnvs } from '@eventbrite/feature-detection';
import { initializeRealUserMonitoring } from '@eventbrite/real-user-monitoring';

type App = {
    name: string;
    version: string;
};

export const RUM_SAMPLE_RATE = 50;

const isProd = (env: CoreEnv) => env.ebDomain.indexOf('eventbrite') > -1;

export const initDatadogRUM = ({ app, env }: { app: App; env: CoreEnv }) => {
    if (isProd(env)) {
        initializeRealUserMonitoring({
            sessionSampleRate: RUM_SAMPLE_RATE,
            version: app.version,
            service: app.name,
            env: EBEnvs.PROD,
        });
    }
};
